/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RemoveRolesAndGroupsDto } from '../models/RemoveRolesAndGroupsDto';
import type { UserInfoDto } from '../models/UserInfoDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserInfoService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Clear the cached UserInfo object.
     * The next call will reload the object from the database.
     * @returns any OK
     * @throws ApiError
     */
    public forgetAboutMe(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/UserInfo/ForgetAboutMe',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the user info of the current user.
     * Some properties are excluded from being sent to the browser by using the [JsonIgnore] attribute
     * on the UserInfo class.
     * "ShortCode" may be sent by the client and is processed in the UserInfoMiddleware class.
     * @param shortCode Optional short code for the user. Middleware will see this query parameter and use it. We don't use it here.
     * @returns UserInfoDto OK
     * @throws ApiError
     */
    public getMyUserInfo(
        shortCode?: string,
    ): CancelablePromise<UserInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/UserInfo/GetMyUserInfo',
            query: {
                'shortCode': shortCode,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the user info of the current user.
     * Some properties are excluded from being sent to the browser by using the [JsonIgnore] attribute
     * on the UserInfo class.
     * "ShortCode" may be sent by the client and is processed in the UserInfoMiddleware class.
     * @param shortCode Optional short code for the user. Middleware will see this query parameter and use it. We don't use it here.
     * @returns UserInfoDto OK
     * @throws ApiError
     */
    public getMyUserInfoAnon(
        shortCode?: string,
    ): CancelablePromise<UserInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/UserInfo/GetMyUserInfoAnon',
            query: {
                'shortCode': shortCode,
            },
        });
    }
    /**
     * set the DefaultSysOrgGuid for the user
     * @param sysOrgGuid
     * @returns boolean OK
     * @throws ApiError
     */
    public setStartingOrg(
        sysOrgGuid: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/UserInfo/{sysOrgGuid}/SetStartingOrg',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the current user's saved HMB dashboard widget layout (serialized GridStack positions).
     * Returns an empty string if they haven't customized it — matching the non-null OpenAPI contract.
     * @returns string OK
     * @throws ApiError
     */
    public getMyDashboardLayout(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/UserInfo/GetMyDashboardLayout',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Save the current user's HMB dashboard widget layout. Self-service: derives the user from
     * the authenticated context and only ever writes the caller's own account.
     * @param requestBody Serialized GridStack positions (JSON string).
     * @returns any OK
     * @throws ApiError
     */
    public saveDashboardLayout(
        requestBody?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/UserInfo/SaveDashboardLayout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Remove specified roles and groups from the cached UserInfo only (not from database).
     * This is useful for testing scenarios. Use "Refresh Settings" to restore original roles/groups.
     * @param requestBody The roles and groups to remove
     * @returns any OK
     * @throws ApiError
     */
    public removeRolesAndGroups(
        requestBody?: RemoveRolesAndGroupsDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/UserInfo/RemoveRolesAndGroups',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
